import * as ConstantPersonHelathCategory from 'constants/person-helath-category';

import LayoutSetLevelZero from 'components/ui/layout-set/general/layout-set-level-zero';

import ParticipantSectionAddNewOptions from 'components/pages/professional/persons/participants/shared/blocks/cmpt-participant-section-add-new-options';

import PageParticipantsList from 'components/pages/professional/persons/participants/list/page-participants-list';

import LayoutSetParticipantDetails from 'components/ui/layout-set/persons/layout-set-participant-details';

import PagePersonDetailsView from 'components/pages/professional/persons/participants/shared/page-person-details-view';

import PageParticipantPersonalInformationAdd from 'components/pages/professional/persons/participants/participant-cred/page-participant-personal-information-add';
import PageParticipantPersonalInformationView from 'components/pages/professional/persons/participants/participant-cred/page-participant-personal-information-view';

import PageSendInvite from 'components/pages/professional/persons/invitations/send-invite/page-send-invite';

import PageParticipantConsultation from 'components/pages/professional/persons/participants/consultation/page-participant-consultation';

import PagePersonProfilePicture from 'components/pages/professional/persons/participants/profile-picture/page-participant-profile-picture';

import PageParticipantAssignedPrograms from 'components/pages/professional/persons/participants/assigned-programs/page-participant-assigned-programs';
import PageSearchPrograms from 'components/pages/professional/programs/shared/search-east/page-search-programs';

import PageParticipantAssignProgram from 'components/pages/professional/persons/participants/assigned-programs/page-participant-assign-program';
import PageCreateAssignedProgram from 'components/pages/professional/programs/shared/create/page-create-assigned-program';

import PageEvolutionDashboard from 'components/pages/professional/persons/participants/participant-evolution/dashboard/page-evolution-dashboard';
import PageEvolutionCredMeasurement from 'components/pages/professional/persons/participants/participant-evolution/measurement/page-evolution-cred-measurement';

import PageEvolutionSettingsGeneral from 'components/pages/professional/persons/participants/participant-evolution/settings/page-evolution-settings-general';
import PageEvolutionSettingsTrackedMeasurements from 'components/pages/professional/persons/participants/participant-evolution/settings/page-evolution-settings-tracked-measurements';

import PageParticipantStatus from 'components/pages/professional/persons/participants/status/page-participant-status';
import PageParticipantDelete from 'components/pages/professional/persons/participants/delete/page-participant-delete';

import { PERSON_KEYS } from 'constants/types';
import { INVITATION_TYPE } from 'constants/values';

const type = PERSON_KEYS.participant;

export default [
  {
    path: '/professional/persons/participants',
    component: LayoutSetLevelZero,
    props: {
      index: true,
    },
    children: [
      {
        path: '',
        name: 'participants-list',
        components: {
          default: PageParticipantsList,
          collapsedMenuTop: ParticipantSectionAddNewOptions,
        },
        props: {
          default: route => ({
            page: Number(route.query.page),
            meta: {
              title: 'label.participants',
              section: 'label.persons',
              navigation: {
                index: 'participants-list',
                edit: 'participant-profile',
                cancel: 'participants-list',
                status: 'participant-status',
              },
            },
          }),
        },
        meta: { auth: true },
        children: [
          {
            path: 'add',
            name: 'add-participant',
            component: PageParticipantPersonalInformationAdd,
            props: {
              meta: {
                title: 'label.add_new_participant',
                navigation: {
                  cancel: 'participants-list',
                  status: 'participant-status',
                  success: 'participant-profile',
                },
              },
            },
            meta: { auth: true },
          },
          {
            meta: { auth: true },
            path: 'invite-participant',
            name: 'participants-invite-participant',
            component: PageSendInvite,
            props: {
              type: INVITATION_TYPE.PARTICIPANT,
              meta: {
                title: 'label.invite_participant',
                navigation: {
                  cancel: 'participants-list',
                  success: 'participants-list',
                },
              },
            },
          },
        ],
      },
    ],
  },
  {
    path: '/professional/persons/participants/:id(\\d+)',
    component: LayoutSetParticipantDetails,
    props: route => ({
      id: route.params.id,
      type,
      meta: {
        navigation: {
          index: 'participants-list',
          cancel: 'participants-list',
          status: 'participant-status',
        },
      },
    }),
    meta: { auth: true },
    children: [
      {
        path: 'profile',
        props: true,
        component: PagePersonDetailsView,
        children: [
          {
            path: 'personal-information',
            name: 'participant-profile',
            component: PageParticipantPersonalInformationView,
            props: route => ({
              id: route.params.id,
              meta: {
                section: 'label.profile',
                title: 'label.personal_information',
                navigation: {
                  cancel: 'participants-list',
                  success: 'participants-list',
                },
              },
            }),
          },
          // {
          //   path: 'health-information',
          //   name: 'participant-health-information',
          //   component: PageParticipantConsultation,
          //   props: route => ({
          //     id: route.params.id,
          //     type,
          //     code: ConstantPersonHelathCategory.PARTICIPANT_HEALTH_INFORMATION,
          //   }),
          // },
          // {
          //   path: 'personal-medical-history',
          //   name: 'participant-personal-medical-history',
          //   component: PageParticipantConsultation,
          //   props: route => ({
          //     id: route.params.id,
          //     code: ConstantPersonHelathCategory.PARTICIPANT_PERSONAL_MEDICAL_HISTORY,
          //   }),
          // },
          {
            path: 'consultation',
            name: 'participant-consultation',
            component: PageParticipantConsultation,
            props: route => ({
              id: route.params.id,
              type,
              code: ConstantPersonHelathCategory.PARTICIPANT_CONSULTATION,
              meta: {
                section: 'label.profile',
                title: 'label.consultation',
                navigation: {
                  cancel: 'participants-list',
                },
              },
            }),
          },
          {
            path: 'picture',
            name: 'participant-profile-picture',
            component: PagePersonProfilePicture,
            props: route => ({
              id: route.params.id,
              type,
              meta: {
                section: 'label.related_content',
                title: 'label.profile_picture',
                navigation: {
                  cancel: 'participants-list',
                },
              },
            }),
          },
          // {
          //   path: 'family-medical-history',
          //   name: 'participant-family-medical-history',
          //   component: PageParticipantConsultation,
          //   props: route => ({
          //     id: route.params.id,
          //     code: ConstantPersonHelathCategory.PARTICIPANT_FAMILY_MEDICAL_HISTORY,
          //   }),
          // },
          // {
          //   path: 'semantic-information',
          //   name: 'participant-health-related-semantic',
          //   component: PageParticipantHealthRelatedSemantic,
          //   props: true,
          // },
        ],
      }, // end ~ profile
      {
        path: 'related-content',
        props: true,
        component: PagePersonDetailsView,
        children: [
          {
            path: 'assigned-programs',
            name: 'participant-assigned-programs',
            component: PageParticipantAssignedPrograms,
            meta: { auth: true },
            props: route => ({
              id: route.params.id,
              type,
              meta: {
                title: 'label.list_of_programs',
                section: 'label.assigned_programs',
                back_to_label: 'label.assigned_programs',
                navigation: {
                  edit: 'diet-basic-information',
                  returnTo: 'participant-assigned-programs',
                },
              },
            }),
            children: [
              {
                path: 'search',
                name: 'participant-search-programs',
                component: PageSearchPrograms,
                meta: { auth: true },
                props: {
                  meta: {
                    title: 'label.use_template',
                    navigation: {
                      cancel: 'participant-assigned-programs',
                      itemClickNavigation: 'participant-assign-program',
                      itemNew: {
                        label: 'label.create_new_assigned_program',
                        name: 'participant-create-assigned-program',
                      },
                    },
                  },
                },
                children: [
                  {
                    path: 'assign-program/:programType/:programID(\\d+)',
                    name: 'participant-assign-program',
                    component: PageParticipantAssignProgram,
                    props: route => ({
                      id: route.params.id,
                      programType: route.params.programType,
                      programID: route.params.programID,
                      meta: {
                        title: 'label.assign_program',
                        navigation: {
                          back: 'participant-search-programs',
                          cancel: 'participant-assigned-programs',
                          success: 'participant-assigned-programs',
                        },
                      },
                    }),
                    meta: {
                      breadcrumb: 'label.assign_program',
                    },
                  },
                  {
                    path: 'create-assigned-program',
                    name: 'participant-create-assigned-program',
                    component: PageCreateAssignedProgram,
                    props: route => ({
                      id: route.params.id,
                      meta: {
                        title: 'label.create_assigned_program',
                        navigation: {
                          back: 'participant-search-programs',
                          cancel: 'participant-assigned-programs',
                          success: 'participant-assigned-programs',
                        },
                      },
                    }),
                  },
                ],
              },
            ],
          },
        ],
      }, // end ~ related-content
      {
        path: 'evolution',
        component: PagePersonDetailsView,
        props: route => ({
          id: route.params.id,
          meta: {
            section: 'label.evolution',
            title: 'label.dashboard',
            navigation: {
              cancel: 'participants-list',
            },
          },
        }),
        meta: { auth: true },
        children: [
          {
            path: 'dashboard',
            name: 'participant-evolution-dashboard',
            component: PageEvolutionDashboard,
            props: route => ({
              id: route.params.id,
              type,
              period: route.query.period,
              date_from: route.query.date_from,
              date_to: route.query.date_to,
              meta: {
                section: 'label.participant_evolution',
                title: 'label.dashboard',
                navigation: {
                  edit: 'participant-evolution-edit-measurement',
                },
              },
            }),
            meta: {
              breadcrumb: 'label.dashboard',
            },
            children: [
              {
                path: 'add-measurement',
                name: 'participant-evolution-add-measurement',
                component: PageEvolutionCredMeasurement,
                props: route => ({
                  id: route.params.id,
                  type,
                  period: route.query.period,
                  date_from: route.query.date_from,
                  date_to: route.query.date_to,
                  meta: {
                    title: 'label.add_measurement',
                    navigation: {
                      cancel: 'participant-evolution-dashboard',
                    },
                  },
                }),
                meta: {
                  breadcrumb: 'pages.participant.add_measurement',
                },
              },
              {
                path: 'edit-measurement/:measurementID(\\d+)',
                name: 'participant-evolution-edit-measurement',
                component: PageEvolutionCredMeasurement,
                props: route => ({
                  id: route.params.id,
                  type,
                  measurementID: route.params.measurementID,
                  period: route.query.period,
                  date_from: route.query.date_from,
                  date_to: route.query.date_to,
                  meta: {
                    title: 'label.edit_measurement',
                    navigation: {
                      cancel: 'participant-evolution-dashboard',
                    },
                  },
                }),
                meta: { auth: true },
              },
            ],
          },
          {
            path: 'settings-general',
            name: 'participant-evolution-settings-general',
            component: PageEvolutionSettingsGeneral,
            props: route => ({
              id: route.params.id,
              type,
              meta: {
                section: 'label.participant_evolution',
                title: 'label.evolution_settings',
                navigation: {
                  cancel: 'participants-list',
                },
              },
            }),
            meta: {
              breadcrumb: 'label.evolution_settings_general',
            },
          },
          {
            path: 'settings-tracked-measurements',
            name: 'participant-evolution-settings-tracked-measurements',
            component: PageEvolutionSettingsTrackedMeasurements,
            props: route => ({
              id: route.params.id,
              type,
              meta: {
                section: 'label.participant_evolution',
                title: 'label.measurement_tracking',
                navigation: {
                  cancel: 'participants-list',
                },
              },
            }),
            meta: {
              breadcrumb: 'label.measurements_tracking',
            },
          },
        ],
      },
      {
        path: 'settings',
        component: PagePersonDetailsView,
        meta: { auth: true },
        props: route => ({
          id: route.params.id,
        }),
        children: [
          {
            path: 'status',
            name: 'participant-status',
            component: PageParticipantStatus,
            props: route => ({
              type,
              id: route.params.id,
              meta: {
                section: 'label.settings',
                title: 'label.status',
                navigation: {
                  index: 'participants-list',
                },
              },
            }),
          },
          {
            path: 'delete',
            name: 'participant-delete',
            component: PageParticipantDelete,
            props: route => ({
              type,
              id: route.params.id,
              meta: {
                title: 'label.delete_participant',
                section: 'label.settings',
                navigation: {
                  index: 'participants-list',
                  success: 'participants-list',
                },
              },
            }),
          },
        ],
      },
      // {
      //   path: 'messages',
      //   name: 'participant-messages',
      //   component: PageParticipantAssignedPrograms,
      //   props: true,
      //   meta: {
      //     breadcrumb: 'pages.participant_messages',
      //   },
      // },
      // {
      //   path: 'questionaries',
      //   name: 'participant-questionaries',
      //   component: PageParticipantAssignedPrograms,
      //   props: true,
      //   meta: {
      //     breadcrumb: 'pages.participant_questionaries',
      //   },
      // },
      // {
      //   path: 'colaboration',
      //   name: 'participant-colaboration',
      //   component: PageParticipantAssignedPrograms,
      //   props: true,
      //   meta: {
      //     breadcrumb: 'pages.participant_colaboration',
      //   },
      // },
    ],
  },
];



// WEBPACK FOOTER //
// ./src/router/professional/persons/router-participants.js